import { render, staticRenderFns } from "./assinatura.vue?vue&type=template&id=99dd875e&scoped=true"
import script from "./assinatura.vue?vue&type=script&lang=ts"
export * from "./assinatura.vue?vue&type=script&lang=ts"
import style0 from "./assinatura.vue?vue&type=style&index=0&id=99dd875e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dd875e",
  null
  
)

export default component.exports